export const mobileMaxWidth = 600;
export const mobileDeviceQuery = `(max-width:${mobileMaxWidth}px)`;
export const mobileDevice = `@media ${mobileDeviceQuery}`;

export function useMediaQuery() {
  let isMobile = false;
  let screenWidth = 0;
  let screenHeight = 0;
  if (typeof window !== 'undefined') {
    isMobile = window.matchMedia(mobileDeviceQuery).matches;
    // innerWidth provides the actual width of the browser window
    screenWidth = window.innerWidth;
    screenHeight = window.innerHeight;
  }
  return {
    isMobile,
    screenWidth,
    screenHeight,
  };
}
